import React from 'react';
import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';

import videoplayback from '../../assets/hiRender video 1.mp4';

// Illustrations
// import IntroImg from '../assets/hiRender_intro_image.svg';
import Slide1 from '../../assets/virtual reality.svg';
import Slide2 from '../../assets/virtual reality 2.svg';
import Slide3 from '../../assets/virtual reality 3.svg';

//Slider or Carousel
import { Swiper, SwiperSlide } from "swiper/react";
import 'swiper/swiper-bundle.min.css'
import 'swiper/swiper.min.css'
import SwiperCore, {
    Navigation,
    Pagination,
    Scrollbar,
    A11y,
    Autoplay,
    EffectCube,
  } from "swiper";

import { Button } from '@material-ui/core';
import getSymbolFromCurrency from 'currency-symbol-map';
// icons 
import CheckRoundedIcon from '@material-ui/icons/CheckRounded';

import {
    handle_activePage,
} from '../../Redux/reducer';

import gtag from 'ga-gtag'

const HiRender = () => {

    const dispatch = useDispatch();
    const showDemo = false;
    
    //Google Analytics
    gtag('event','Entered_hiRender_page')

    SwiperCore.use([Navigation, Pagination, Scrollbar, A11y, Autoplay, EffectCube]);
    return(
        <div className='hiRender-page'>
            <div className='hiRender-intro-section'>
                <div className='hiRender-intro-logo-container'>
                    <div className='hiRender-intro-logo active-section fade-left'></div>
                    {/* <div className='hiRender-intro-text'>
                        Bringing the holy grail of lively meetings in your hands.
                    </div> */}
                </div>
                <div className='hiRender-intro-image-container'>
                    {/* <img src={IntroImg} className='hiRender-intro-image'/> */}
                    <div className='hiRender-intro-image active-section fade-right'></div>
                </div>
                
            </div>
            <div className='hiRender-why-section'>
                
                <div className='hiRender-why-slider-container'>
                    <div className='hiRender-why-title'>
                        WHY
                    </div>
                    <div className='hiRender-why-slider'>
                        <Swiper
                            slidesPerView={1}
                            loop={true}
                            autoplay={{ delay: 4000 }}
                            className="slides"
                        >
                            <SwiperSlide>
                                <div className='hiRender-why-slide-image-container'>
                                <img src={Slide1} className='hiRender-why-slide-image' alt='SlideImage'/>
                                </div> 
                                <div className='hiRender-why-slide-text'>
                                    Meet anyone, anytime, anywhere!.
                                </div>
                            </SwiperSlide>
                            <SwiperSlide>
                                    <div className='hiRender-why-slide-image-container'>
                                    <img src={Slide2} className='hiRender-why-slide-image' alt='SlideImage'/>
                                    </div>
                                    <div className='hiRender-why-slide-text'>
                                        Bringing the holy grail of lively meetings in your hands.
                                    </div>
                            </SwiperSlide>
                            <SwiperSlide>
                                    <div className='hiRender-why-slide-image-container'>
                                        <img src={Slide3} className='hiRender-why-slide-image' style={{width:"100%"}} alt='SlideImage'/>
                                    </div>
                                    <div className='hiRender-why-slide-text'>
                                        Enjoy the whole new world of realism.
                                    </div>
                            </SwiperSlide>
                        </Swiper>
                    </div>
                </div>
            </div>
            <div className='hiRender-feature-section'>
                <div className='hiRender-feature-container'>
                    <video className="hiRender-feature-video" autoPlay loop muted >
                        <source src={videoplayback}/>
                    </video>
                    {/* <div className='hiRender-feature-details'>
                        <div className='hiRender-features-title'>
                            APPLICATIONS
                        </div>
                        <div className='hiRender-features-list reveal fade-right'>
                            <ul>
                                <li>feature 1</li>
                                <li>feature 1</li>
                                <li>feature 1</li>
                            </ul>
                        </div>
                    </div> */}
                </div>
            </div>
            { showDemo == true ? <div className='hiRender-demo-section'>
                <div className='hiRender-demo-container'>
                    <Link to='/hiRender/demo' className='demoButton' onClick={()=>dispatch(handle_activePage("hiRender"))}>
                        <Button className='hiRender-demo-button' variant="contained" color="dark">
                            <h2>Start Demo</h2>
                        </Button>
                    </Link>
                </div>
            </div> : null }
            <div className='hiRender-plans-section'>
                {/* <div className='hiRender-plans-container reveal fade-bottom'>
                    <div className='price-plans'>
                        <h3 className='planName'>Basic</h3>
                        <div className='planPrice'>
                            <h1>Free</h1> 
                            <h3>/month /registration</h3>
                        </div>
                        <ul className='planBenifits'>
                            <li><CheckRoundedIcon className='checkIcon'/><p>Point 1</p></li>
                            <li><CheckRoundedIcon className='checkIcon'/><p>Point 2</p></li>
                            <li><CheckRoundedIcon className='checkIcon'/><p>Point 3</p></li>
                        </ul>
                        <div className='planButtonDiv'>
                            <Button className='planButton' variant="outlined" color="primary">Sign up</Button>
                        </div>
                    </div>
                    <div className='price-plans'>
                        <h3 className='planName'>Pro</h3>
                        <div className='planPrice'>
                            <h1>{getSymbolFromCurrency('INR')}400</h1> 
                            <h3>/month /subscription</h3>
                        </div>
                        <ul className='planBenifits'>
                            <li><CheckRoundedIcon className='checkIcon'/><p>Point 1</p></li>
                            <li><CheckRoundedIcon className='checkIcon'/><p>Point 2</p></li>
                            <li><CheckRoundedIcon className='checkIcon'/><p>Point 3</p></li>
                            <li><CheckRoundedIcon className='checkIcon'/><p>Point 4</p></li>
                            <li><CheckRoundedIcon className='checkIcon'/><p>Point 5</p></li>
                        </ul>
                        <div className='planButtonDiv'>
                            <Button className='planButton' variant="outlined" color="secondary">Pay now</Button>
                        </div>
                    </div>
                </div> */}
                <div className='plans-comingSoon reveal fade-bottom'>
                    "Coming Soon"
                </div>
            </div>
        </div>
    )
}

export default HiRender;
